import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import moment from 'moment';

import api, { apiLog } from '~/services/api';
import history from '~/services/history';
import { isNullOrEmpty } from '~/helpers/util';
import { CatchErrors } from '../common';

import { signInSuccess, signFailure, recoverySuccess, recoveryFailure } from './actions';

export function* signIn({ payload }) {
  try {
    const { email, password } = payload;

    const formData = new FormData();

    formData.append('email', email);
    formData.append('password', password);

    const response = yield call(api.post, 'login', formData);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const { token } = result.data;

    const user = {
      id: result.data.id,
      name: result.data.name,
      email: result.data.email,
      active: result.data.active,
      level: result.data.level,
      organizationId: result.data.organizationId,
      organizationName: result.data.organizationName,
      createdAt: result.data.createdAt
    };

    api.defaults.headers.Authorization = `Bearer ${token}`;
    apiLog.defaults.headers.Authorization = `Bearer ${token}`;

    yield put(signInSuccess(token, user));

    history.push('/');
  }
  catch (err) {
    CatchErrors(err);
    yield put(signFailure());
  }
}

export function* signUp({ payload }) {
  try {
    const { organization, name, email, emailConfirm, password, passwordConfirm, birth } = payload;

    const formData = new FormData();

    formData.append('organization', organization);
    formData.append('name', name);
    formData.append('email', email);
    formData.append('emailConfirm', emailConfirm);
    formData.append('password', password);
    formData.append('passwordConfirm', passwordConfirm);
    if (!isNullOrEmpty(birth)) formData.append('birth', moment(birth).format('YYYY-MM-DD'));

    const response = yield call(api.post, 'register', formData);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    toast.success(result.message);

    history.push('/login');
  }
  catch (err) {
    CatchErrors(err);
  }
  finally {
    yield put(signFailure());
  }
}

export function* recovery({ payload }) {
  try {
    const { email } = payload;

    const formData = new FormData();

    formData.append('email', email);

    const response = yield call(api.post, 'recovery', formData);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;

    toast.success(result.message);

    yield put(recoverySuccess());

    history.push('/');
  }
  catch (err) {
    CatchErrors(err);
    yield put(recoveryFailure());
  }
}

export function* recoveryUpdate({ payload }) {
  try {
    const { token, code, password, passwordConfirm } = payload;

    const formData = new FormData();

    formData.append('code', code);
    formData.append('password', password);
    formData.append('passwordConfirm', passwordConfirm);

    const response = yield call(api.post, `recovery/${token}`, formData);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;

    toast.success(result.message);

    yield put(recoverySuccess());

    history.push('/');
  }
  catch (err) {
    CatchErrors(err);
    yield put(recoveryFailure());
  }
}

export function* setToken({ payload }) {
  if (!payload) return;

  const { token, profile } = payload.auth;

  if (!token || !profile) {
    yield put(signFailure());
    return;
  }

  api.defaults.headers.Authorization = `Bearer ${token}`;
  apiLog.defaults.headers.Authorization = `Bearer ${token}`;

  yield put(signInSuccess(token, profile));
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/SIGN_IN_REQUEST', signIn),
  takeLatest('@auth/SIGN_UP_REQUEST', signUp),
  takeLatest('@auth/RECOVERY_REQUEST', recovery),
  takeLatest('@auth/RECOVERY_UPDATE_REQUEST', recoveryUpdate),
]);